export default __webpack_public_path__ + "static/media/tts-emphasis.b9c40f57.svg";